<template>
  <div class="gsap">
    <svg id="demo" xmlns="http://www.w3.org/2000/svg" width="2000" height="350" viewBox="0 0 1000 400">
      <defs>
        <clipPath id="theClipPath">
          <rect x="350" y="219" width="300" height="80" fill="yellow" />
        </clipPath>
      </defs>

      <g id="letters" fill="none" stroke="#FFF" stroke-miterlimit="10" stroke-width="1" transform="translate( 106.3 0)">
        <path id="letter0" d="M127 57V197H125V127H26V197H24V57H26V125H125V57H127Z" />
        <path id="letter1" d="M178 57V195H249V197H175V57H178Z" />
        <path id="letter2" d="M327 197V197Q338 197 347 193 356 189 362 182 368 175 372 166 375 156 375 145V145 57H377V145Q377 157 374 166 370 176 364 183 357 191 348 195 338 199 327 199V199Q315 199 306 195 296 191 290 183 283 176 280 166 276 157 276 145V145 57H278V145Q278 156 282 165 285 175 291 182 297 189 306 193 315 197 327 197Z"/>
        <path id="letter3" d="M404 57H512V60H460V197H457V60H404V57Z"/>
        <path id="letter4" d="M590 197V197Q601 197 610 193 619 189 625 182 631 175 635 166 638 156 638 145V145 57H640V145Q640 157 637 166 633 176 627 183 620 191 611 195 602 199 590 199V199Q578 199 569 195 559 191 553 183 546 176 543 166 539 157 539 145V145 57H542V145Q542 156 545 165 548 175 554 182 561 189 570 193 579 197 590 197Z"/>
        <path id="letter5" d="M716 130H694V197H691V57H724Q746 57 757 66 769 74 769 92V92Q769 101 766 108 763 115 757 119 751 124 742 127 734 130 724 130V130Q725 130 726 131 726 132 727 132V132L782 197H780Q779 197 779 197 778 197 778 196V196L725 133Q724 132 723 132 723 131 722 131 721 130 719 130 718 130 716 130V130Z"/>
        <path id="letter6" d="M693.80 59.40L693.80 127.80L722.00 127.80Q732.30 127.80 740.55 125.35Q748.80 122.90 754.65 118.35Q760.50 113.80 763.65 107.25Q766.80 100.70 766.80 92.40L766.80 92.40Q766.80 75.30 755.70 67.35Q744.60 59.40 723.80 59.40L723.80 59.40L693.80 59.40Z"/>
      </g>

      <text transform="translate(500 390)" font-size="24" text-anchor="middle" font-weight="600" fill="#fff">
        {{ title }}
      </text>

      <line id="underline" x1="480" y1="300" x2="520" y2="300" stroke-width="2" stroke="#d55300" opacity="0" />

      <g id="container"></g>
      <g clip-path="url(#theClipPath)">
        <text id="end" transform="translate(500 284)" font-size="48" text-anchor="middle" font-weight="600" fill="#fff">{{ company }}</text>
      </g>
    </svg>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

export default {
  name: "Gsap",
  props: ["company", "title"],
  mounted() {
    console.clear();
    console.log("Starting animations", this.company, this.title);
    gsap.registerPlugin(MotionPathPlugin);
    this.render();
  },
  methods: {
    render: function() {
      const svgns = "http://www.w3.org/2000/svg";
      let container = document.querySelector("#container");
      let targets = [];
      let targetArrays = [];
      let localTargets = [];
      let size = 15; // use for width and height of rectangles
      let fillFactor = 0.65; // percentage - how densely packed each path is with rectangles
      let offsetLogoText = 106.3;
      const color = "#46a2e0";
      const gotoColor = "#cf5b21";

      const anim = gsap.timeline({ delay: 0.75, repeat: -1, repeatDelay: 5 });

      let paths = document.querySelectorAll("path");

      for (let i = 0; i < paths.length; i++) {
        let pathPoints = MotionPathPlugin.getRawPath(paths[i])[0];
        let pathLength = MotionPathPlugin.getLength(paths[i]);
        let count = Math.floor((pathLength / size) * fillFactor);

        let newX = pathPoints[0];
        let newY = pathPoints[1];

        localTargets = [];
        for (let j = 0; j < count; j++) {
          let newRect = document.createElementNS(svgns, "rect");
          container.appendChild(newRect);
          gsap.set(newRect, { x: newX, y: newY, fill: color, attr: { rx: 0, ry: 0, x: offsetLogoText, y: 0, width: size, height: size } });
          localTargets.push(newRect);
          targets.push(newRect);
        }

        targetArrays.push(localTargets);
      }

      gsap.set("svg", { opacity: 1 });

      // get the rectangles centered and ready for motion
      gsap.set(targets, { xPercent: -50, yPercent: -50, transformOrigin: "50% 50%", scale: 0 });

      anim.to(targets, { scale: 1, ease: "elastic", duration: 1.25 });

      // make an amimation for all paths and the targets
      for (let i = 0; i < targetArrays.length; i++) {
        anim.to(targetArrays[i], {motionPath: { path: paths[i], autoRotate: true, start: 0, end: gsap.utils.distribute({ base: 0,amount: 1})}, duration: 0.4 });
      }

      // random colors
      anim.to(targets, {
        fill: "random([#1bb1a5, #94c356, #e3aa59, #a63ba0, #cf5b21, #46a4cc])",
        duration: 0.45,
        ease: "none",
        stagger: {
          amount: 2,
          from: "end"
        }
      });

      // cycle scale with wrap()
      anim.to(targets, {
        scale: gsap.utils.wrap([1.3, 1.6, 1.9, 2.2]),
        duration: 0.35,
        ease: "power3.inOut",
        stagger: {
          amount: 3,
          yoyo: true,
          repeat: 1
        }
      });
      // rectangles to circles and change to basic color
      anim.to(targets, {
        rotation: "+=360",
        duration: 0.75,
        fill: gotoColor,
        attr: { rx: size / 2, ry: size / 2 },
        stagger: { amount: 3, from: "end" }
      });
      // back to rectangles
      anim.to(targets, { attr: { rx: 0, ry: 0 } });

      // move all targets to central point
      anim.to(targets, { x: 500-offsetLogoText, y: 300, rotation: 0, attr: { height: 2, width: 40}, stagger: {amount: 1.3, from: "center" }}, "+=0.5");

      // bye bye targets
      anim.set(targets, { opacity: 0 });

      // hello underline
      anim.set("#underline", { opacity: 1 });

      // expand underline
      anim.to("#underline", { attr: { x1: 200, x2: 800 }, ease: "power3.inOut" });

      anim.from("#end", { duration: 0.65, y: 340 });

      anim.delay(3);
    }
  }
};
</script>

<style>
.gsap {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  font-family: "Signika Negative", sans-serif;
  background: #262626;
}

svg {
  max-width: 100%;
  max-height: 100%;
  opacity: 0;
}
</style>
